<!--Create Environment Title-->
<h2>Create Environment</h2>
<p>Account ID: {{createCloudEnvironmentRequest.accountId}}</p>
<form #createEnvironmentForm="ngForm" novalidate>
    <mat-dialog-content>
        <!--Dialog Content-->
        <div *ngIf="!createCloudEnvironmentResponse">
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Name</mat-label>
                    <input aria-required="true" required matInput [(ngModel)]="createCloudEnvironmentRequest.name"
                        name="envName" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Description</mat-label>
                    <input matInput [(ngModel)]="createCloudEnvironmentRequest.description" name="description" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Schema Name</mat-label> <!-- Validate string does not contain / or \ -->
                    <input aria-required="true" required matInput [(ngModel)]="createCloudEnvironmentRequest.schemaName"
                        name="schemaName" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Version</mat-label>
                    <mat-select placeholder="x.x.x.x" aria-required="true" required 
                        [(ngModel)]="createCloudEnvironmentRequest.version" name="version">
                        <mat-option *ngFor="let version of environmentVersions"
                            [value]="version">
                            <span>{{version}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Deployment Type</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="createCloudEnvironmentRequest.deploymentType"
                        name="deploymentType" aria-disabled="true" disabled="true">
                        <mat-option *ngFor="let item of createCloudEnvironmentDialogData.deploymentTypes"
                            [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <section>
                    <mat-checkbox [(ngModel)]="createCloudEnvironmentRequest.isProduction" name="isProduction">Is
                        Production</mat-checkbox>
                </section>
            </div>
        </div>
        <div *ngIf="createCloudEnvironmentResponse">
            <label>Environment Id: {{createCloudEnvironmentResponse.environmentId}}</label>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <!--Dialog action buttons-->
        <button mat-raised-button color="primary" (click)="save()"
            [disabled]="createEnvironmentForm.form.invalid || isSaving" *ngIf="!createCloudEnvironmentResponse">
            <span *ngIf="!isSaving">Save</span>
            <span *ngIf="isSaving">Saving...</span>
        </button>
        <button mat-raised-button [disabled]="isSaving" (click)="close()">Cancel</button>
    </mat-dialog-actions>
</form>